import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ProjectService } from '../project-service/project.service';
import { AuthService } from '../auth/auth.service';

@Injectable({
    providedIn: 'root',
})
export class ThemesService {

    constructor(
        private projectService: ProjectService,
        private authService: AuthService,
    ) {}

    async loadTheme(): Promise<void> {
        await new Promise(async (resolve, reject) => {
            const projectId = this.authService.projectId;
            const path = `themes/${projectId}/theme.css`;
            const encodedPath = encodeURIComponent(path);
            const cssUrl = `https://firebasestorage.googleapis.com/v0/b/${environment.firebase.storageBucket}/o/${encodedPath}?alt=media&v=${new Date().getTime()}`;
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = cssUrl;
            link.onload = () => resolve(void 0);
            link.onerror = (error) => reject(error);

            document.head.appendChild(link);
        });
    }

    async loadLogo(): Promise<void> {
        const projectId = this.authService.projectId;
        const project = await this.projectService.getProjectById(projectId);
        localStorage.setItem('projectLogo', project.logo);
  }
}
